import * as Sentry from "@sentry/react";

/**
 * Starts a Sentry replay with proper error handling.
 * If a replay is already in progress, it will ignore the error.
 */
export const attemptToStartSentryReplay = (): void => {
  const replay = Sentry.getReplay();
  if (replay) {
    try {
      replay.start();
    } catch (error) {
      // If replay is already in progress, ignore the error
      if (
        error instanceof Error &&
        !error.message?.includes("already in progress")
      ) {
        console.debug("Sentry replay error:", error);
      }
    }
  }
};
